"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ExampleScenario_Step = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_ExampleScenario_Process_1 = require("./RTTI_ExampleScenario_Process");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_ExampleScenario_Operation_1 = require("./RTTI_ExampleScenario_Operation");
var RTTI_ExampleScenario_Alternative_1 = require("./RTTI_ExampleScenario_Alternative");
exports.RTTI_ExampleScenario_Step = t.recursion('IExampleScenario_Step', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        process: t.array(RTTI_ExampleScenario_Process_1.RTTI_ExampleScenario_Process),
        pause: t.boolean,
        _pause: RTTI_Element_1.RTTI_Element,
        operation: RTTI_ExampleScenario_Operation_1.RTTI_ExampleScenario_Operation,
        alternative: t.array(RTTI_ExampleScenario_Alternative_1.RTTI_ExampleScenario_Alternative)
    });
});
//# sourceMappingURL=RTTI_ExampleScenario_Step.js.map